const splitAndCleanup = (string) => {
  if (string && (typeof string === 'string')) {
    return string.split(/\r?\n|\. /).filter(str => str.trim()).map(str => `${str.trim()}.`)
  } else {
    return []
  }
}

export default splitAndCleanup
